import React, { useState, useCallback } from "react";
import Dropzone from "react-dropzone";
import { useTranslation } from "react-i18next";
import cn from "classnames";

import Label from "components/InputsField/Label";
import InputError from "components/InputsField/InputError";
import { showErrorMessage } from "helpers/notifications";
import { JPEG, JPG, PNG, FILE_SIZE, INVALID_FILE_ERROR, LARGE_FILE_ERROR } from "constants/files";

import styles from "./styles.module.scss";

const MAX_FILES_COUNT = 1;

const LogotypeInput = ({
    wrapperClassName,
    fileFormats = [JPEG, JPG, PNG],
    name,
    label,
    onChange,
    uploadedFile,
    setTouched,
    errorMessage,
    errorMode,
}) => {
    const { t } = useTranslation();
    const [file, setFile] = useState(uploadedFile || null);

    const handleDrop = (acceptedFiles) => {
        if (acceptedFiles.length > 0) {
            const file = {
                file: acceptedFiles[0],
                preview: URL.createObjectURL(acceptedFiles[0]),
            };
            setFile(file);
            onChange(file);
        }
        setTouched && setTouched(true);
    };

    const handleRemoveLogotype = () => {
        setFile(null);
        onChange(null);
    };

    const handleDropReject = useCallback(
        (e) => {
            if (e[0].errors.find((error) => error.code === LARGE_FILE_ERROR)) {
                showErrorMessage(t("errors.fileSize"));
            }
            if (e[0].errors.find((error) => error.code === INVALID_FILE_ERROR)) {
                showErrorMessage(t("errors.fileExtension"));
            }
        },
        [t],
    );

    return (
        <div className={cn(styles.wrapper, wrapperClassName)}>
            {label && <Label label={label} name={name} require={true} />}
            <Dropzone
                onDrop={handleDrop}
                name={name}
                maxSize={FILE_SIZE}
                accept={fileFormats}
                multiple={false}
                maxFiles={MAX_FILES_COUNT}
                onDropRejected={handleDropReject}
            >
                {({ getRootProps, getInputProps }) => (
                    <div className={styles.dropzone} {...getRootProps()}>
                        {file ? (
                            <img src={file.preview} alt="" className={styles.preview} />
                        ) : (
                            <div className={styles.logo} />
                        )}
                        <input {...getInputProps()} accept={fileFormats} />
                        {file && (
                            <button
                                type="button"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleRemoveLogotype();
                                }}
                                className={styles.delete}
                            />
                        )}
                    </div>
                )}
            </Dropzone>
            {errorMessage && <InputError message={errorMessage} mode={errorMode || "top-right"} />}
        </div>
    );
};

export default LogotypeInput;
